import React, { useState } from "react";
import { Alert, Form, Input, DatePicker, Checkbox, Card } from "antd";
import { isNilOrEmpty } from "@salespark/toolkit";
import { useTranslation } from "react-i18next";

const { TextArea } = Input;

const GiftSection = ({ visible, close, onConfirm, data, form }) => {
  const { t } = useTranslation();
  const existsDeliveryDate = !isNilOrEmpty(form.getFieldValue("gift_delivery_date"));
  const [showDeliveryDate, setShowDeliveryDate] = useState(existsDeliveryDate);

  // const onFinish = (values) => {
  //   if (values.gift_email !== values.gift_email_confirm) {
  //     if (values?.gift_email_confirm?.length === 0 || isNilOrEmpty(values.gift_email_confirm) === true) {
  //       form.setFields([
  //         { name: "gift_email_confirm", errors: ["A confirmação do email é um campo obrigatório para garantir que o endereço de email está correto."] },
  //       ]);
  //       return;
  //     }

  //     form.setFields([{ name: "gift_email_confirm", errors: ["O email de confirmação não coincide com o email indicado."] }]);
  //     return;
  //   }

  //   // Check if delivery date is not set when showDeliveryDate is true,
  //   // if so, check if date and time is before current date and time,
  //   // if so, show a mensage (no error, just a mensage) and proceed
  //   if (showDeliveryDate === true && moment(values.gift_delivery_date).isBefore(moment())) {
  //     confirm({
  //       title: "Atenção: data de entrega no passado",
  //       content: "A data escolhida para a entrega da oferta é anterior à data e hora atuais. Neste caso, a oferta será enviada de imediato. Queres continuar?",
  //       okText: "Sim",
  //       cancelText: "Não",
  //       onOk() {
  //         onConfirm(values);
  //       },
  //       onCancel() {
  //         return;
  //       },
  //     });
  //     return;
  //   }

  //   onConfirm(values);
  // };

  return (
    <Card className="gift-card" title={t("gift.cardTitle")} type="inner" style={{ marginTop: 15, marginBottom: 15 }}>
      <Alert style={{ marginBottom: 15 }} message={t("gift.alertMessage")} />
      <Form.Item
        label={t("gift.nameLabel")}
        name="gift_name"
        rules={[
          { required: true, message: t("gift.required") },
          {
            min: 3,
            message: t("gift.nameTooShort"),
          },
          { max: 80, message: t("gift.nameTooLong") },
        ]}
      >
        <Input placeholder={t("gift.namePlaceholder")} />
      </Form.Item>

      <Form.Item label={t("gift.emailLabel")} name="gift_email" rules={[{ required: true, message: t("gift.required") }]}>
        <Input placeholder={t("gift.emailPlaceholder")} onChange={() => form.validateFields(["gift_email_confirm"])} />
      </Form.Item>

      <Form.Item
        label={t("gift.emailConfirmLabel")}
        name="gift_email_confirm"
        rules={[
          {
            validator: async (rule, value) => {
              // Before throwing error, check if value has @ domains and tld
              const emailValue = form.getFieldValue("gift_email");
              if (
                isNilOrEmpty(value) === false &&
                isNilOrEmpty(emailValue) === false &&
                value?.toLowerCase() !== emailValue?.toLowerCase().substring(0, value.length)
              ) {
                throw new Error(t("gift.emailMismatch"));
              }
            },
          },
        ]}
      >
        <Input placeholder={t("gift.emailConfirmPlaceholder")} autoComplete="new-password" onPaste={(e) => e.preventDefault()} />
      </Form.Item>

      <Form.Item
        label={t("gift.messageLabel")}
        name="gift_message"
        rules={[
          {
            min: 10,
            message: t("gift.messageTooShort"),
          },
          { max: 1200, message: t("gift.messageTooLong") },
        ]}
      >
        <TextArea rows={4} placeholder={t("gift.messagePlaceholder")} />
      </Form.Item>

      <Form.Item valuePropName="checked" className="mb-0">
        <Checkbox checked={showDeliveryDate} onChange={(e) => setShowDeliveryDate(e.target.checked)}>
          {t("gift.scheduleCheckbox")}
        </Checkbox>
      </Form.Item>

      {showDeliveryDate === true && (
        <Form.Item label={t("gift.deliveryDateLabel")} name="gift_delivery_date">
          <DatePicker showTime showSecond={false} format="DD-MM-YYYY HH:mm" />
        </Form.Item>
      )}
    </Card>
  );
};

export default GiftSection;
